import * as THREE from 'three';
export class loadCamera{
    camera;
    constructor() {
        this.Start();
    }
    Start(){
        let self = this;
        self.camera = new THREE.PerspectiveCamera(75,window.innerWidth/window.innerHeight,0.1,100);
        self.camera.position.set(-5,2,4);
        self.camera.lookAt(0,-5,0);
    }
    getCamera(){
        return this.camera;
    }
}
